import { render, staticRenderFns } from "./SolicitudesVehiculosIndex.vue?vue&type=template&id=2059dd1a"
import script from "./SolicitudesVehiculosIndex.vue?vue&type=script&lang=js"
export * from "./SolicitudesVehiculosIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports